import { useDispatch } from 'react-redux';
import { isFeatureActive } from '@helpers';
import { FiltersListItemMobile as FiltersListItem } from '@common/Filters/containers/FiltersListItemMobile';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslate } from '@common/Translations';
import { toggleMultipleFilters } from '../actions/filtersActions';
import { FAVORITES } from '../constants';
import { getAvailableInBrandGroup, isCustomBrandSelected } from '../helpers';

export function BrandsGroupsListMobile({ brandGroupsData, brands, activeBrandIds }) {
    const dispatch = useDispatch();
    const translate = useTranslate();
    const config = useConfig();

    const isHighlightsFilterActive = isFeatureActive('PLT-40756-reactivate-highlighted-filter-in-brands', config);

    const handleClick = (brandGroup, isBrandGroupSelected) => {
        dispatch(toggleMultipleFilters(brandGroup, isBrandGroupSelected));
    };

    return (
        brandGroupsData
            ?.filter(({ brandgroupId }) => {
                if (brandgroupId === FAVORITES) {
                    return true;
                }

                return isHighlightsFilterActive;
            })?.map(({ brandgroupId, brandIds }) => {
                const brandGroups = getAvailableInBrandGroup(brandIds, brands);
                const isSelected = isCustomBrandSelected(brandGroups, activeBrandIds);
                const name = brandgroupId === FAVORITES
                    ? translate('brandaz.favorites.label')
                    : translate(`listing.brandgroups.${brandgroupId}.label`);

                return brandGroups.length > 0
                && (
                    <FiltersListItem
                        key={brandgroupId}
                        customClick={() => { handleClick(brandGroups, isSelected); }}
                        item={{
                            name,
                            isSelected
                        }}
                    >
                        {name}
                    </FiltersListItem>
                );
            })
    );
}
